<template>
  <div>
    <private-layer>
      <template slot="box-inner">
        <div class="content clearfix">
          <div class="item" v-if="roleId == 1">
            <div class="icon">
              <i class="iconfont icon-users"></i>
            </div>
            <div class="text">
              <div class="label">用户数</div>
              <div class="value" id="userCounts">{{userCounts}}个</div>
            </div>
          </div>
          <div class="item">
            <div class="icon">
              <i class="iconfont icon-cheliang"></i>
            </div>
            <div class="text">
              <div class="label">车辆总数</div>
              <div class="value" id="carCounts">{{carCounts}}辆</div>
            </div>
          </div>
          <div class="item">
            <div class="icon">
              <i class="iconfont icon-weibiaoti2"></i>
            </div>
            <div class="text">
              <div class="label">在线率</div>
              <div class="value">{{onlineRate}}%</div>
            </div>
          </div>
          <div class="item">
            <div class="icon">
              <i class="iconfont icon-icon-alarm"></i>
            </div>
            <div class="text">
              <div class="label">报警数</div>
              <div class="value">{{alarmCounts}}次</div>
            </div>
          </div>
        </div>
      </template>
    </private-layer>
  </div>
</template>

<script>
import PrivateLayer from '../layer'
import { GetCarInfo } from '@/api/home'
export default {
  components: { PrivateLayer },
  data(){
    return {
      userCounts: '',
      carCounts: '',
      alarmCounts: '',
      onlineRate: '',
      roleId: ''
    }
  },
  created() {
    this.initCarInfo();
  },
  methods: {
    initCarInfo(){
      GetCarInfo().then(res => {
        this.userCounts = res.userCounts;
        this.carCounts = res.carCounts;
        this.alarmCounts = res.alarmCounts;
        this.onlineRate = res.onlineRate;
        this.roleId = res.roleId;
      })
    }
  }
}
</script>

<style lang="less" scoped>
.content {
  padding: 2px 12px 2px;
  color: #fff;
  .item {
    display: flex;
    float: left;
    width: 50%;
    margin: 10px 0;
    .icon {
      width: 46px;
      height: 46px;
      background: #152e5b;
      text-align: center;
      line-height: 46px;
      .iconfont {
        color: #fff;
        font-size: 20px;
      }
    }
    .text {
      flex: 1;
      min-width: 0;
      padding-left: 10px;
    }
  }
}
</style>